@if (items.length === 0) {
  <span class="text-subdued px-8 py-2 text-sm">
    No Notebooks found
  </span>
}

<div appSelectableList #appSelectableList="appSelectableList" [deselectOnReclick]="false">
  <app-sidebar-item
    class="rounded [&:not(.drag-over)]:hover:bg-hover"
    *nestedFor="
      let notebook of items;
      let index = index;
      let depth = depth;
      let expandable = expandable;
      let itemExpanded = expanded;
      stateKey: treeStateKey;
    "
    [title]="notebook.title"
    [depth]="depth"
    [badge]="{ template: badgeTemplate, context: { flagged: notebook.flagged, pinned: notebook.pinned, snoozed: notebook.snoozed, followed: notebook.followed } }"
    iconSlot="none"
    [expandable]="expandable"
    [expanded]="itemExpanded.value"
    [active]="selectedItemsIds | includesBy : notebook?.id"
    (onExpand)="itemExpanded.next($event)"
    (appClick)="openItem(notebook)"
    (appDblClick)="handleDblClick(notebook)"
    [appNotebookContextMenu]="notebook"
    (appNotebookContextMenuOpenNotebook)="handleMenuOpen(notebook)"
    [appSelectable]="notebook?.id"
    [appSelectablePosition]="index"
    [appSelectableIdentifier]="notebook?.id"
    [appSelectableListRef]="appSelectableList"

    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate(notebook)"
    (appDroppableDrop)="dndDrop($event, notebook)"

    appDraggable
    [appDraggableData]="items | selectedItemsDragData: selectedItemsIds: notebook"
    [appDraggablePlaceholder]="placeholder"
    [appDraggablePlaceholderContext]="{ item: notebook }"
    />
  </div>

  <ng-template #badgeTemplate let-flagged=flagged let-pinned=pinned let-snoozed=snoozed let-followed=followed>
    <div class="badge-template h-full flex flex-col justify-center items-center">
      @if (pinned) {
        <app-icon
          class="text-primary"
          size="xs"
          name="sapphire-pin-filled"
        />
      }
      @if (flagged) {
        <app-icon
          class="text-orange-500"
          name="sapphire-flagged-filled"
          size="xs"
        />
      }
      @if (snoozed) {
        <app-icon
          class="text-orange-500"
          name="sapphire-snooze"
          size="xs"
        />
      }
      @if (followed) {
        <app-icon
          class="text-primary"
          name="sapphire-follow-up"
          size="xs"
        />
      }
    </div>
  </ng-template>
